import { useWizardContext } from '@lounge-fe/ui-kit'
import { useEffect } from 'react'
import { useFittingRoomStore } from '../store'

export const StoreStateSync = () => {
  const { activeStep } = useWizardContext()
  const store = useFittingRoomStore()

  useEffect(() => {
    store.setActiveStep(activeStep)
  }, [activeStep])

  return null
}
